import { jsxs, jsx } from 'react/jsx-runtime';
import { mergeStyleSets, Stack, Text, FontIcon, Link } from '@fluentui/react';
import { useBoolean } from '@fluentui/react-hooks';
import { useRef, useEffect } from 'react';
import { sharedClassNames } from '../../../styles.esm.js';
import { COPY_TENANT_ID_TIMEOUT_IN_MS } from './constants.esm.js';
import { useTranslation } from 'react-i18next';
import logger from '@agoras/logger';
import { headerContext } from '../../../../context.esm.js';

function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var classNames = mergeStyleSets({
    fontIcon: {
        cursor: 'pointer'
    },
    subTitle: {
        fontWeight: 600
    }
});
var TenantDetails = function(param) {
    var tenantId = param.tenantId, defaultDomain = param.defaultDomain, displayName = param.displayName;
    var _useBoolean = _sliced_to_array(useBoolean(false), 2), isTenantCopied = _useBoolean[0], _useBoolean_ = _useBoolean[1], setTenantIsCopied = _useBoolean_.setTrue, setTenantIsNotCopied = _useBoolean_.setFalse;
    var _useBoolean1 = _sliced_to_array(useBoolean(false), 2), shownTenantId = _useBoolean1[0], _useBoolean_1 = _useBoolean1[1], showTenantId = _useBoolean_1.setTrue;
    var tenantIconName = isTenantCopied ? 'Accept' : 'Copy';
    var timerId = useRef(null);
    useEffect(function() {
        return function() {
            if (timerId.current) {
                clearTimeout(timerId.current);
            }
        };
    }, []);
    var handleCopyTenantClick = function() {
        var _ref = _async_to_generator(function() {
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        logger.info('', _object_spread({
                            action: 'MyAccount',
                            actionModifier: 'View tenant click'
                        }, headerContext));
                        if (!tenantId) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            navigator.clipboard.writeText(tenantId)
                        ];
                    case 1:
                        _state.sent();
                        setTenantIsCopied();
                        timerId.current = window.setTimeout(setTenantIsNotCopied, COPY_TENANT_ID_TIMEOUT_IN_MS);
                        _state.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleCopyTenantClick() {
            return _ref.apply(this, arguments);
        };
    }();
    var t = useTranslation('header').t;
    if (!tenantId) {
        return;
    }
    return /*#__PURE__*/ jsxs(Stack, {
        children: [
            /*#__PURE__*/ jsx(Text, {
                variant: "mediumPlus",
                className: classNames.subTitle,
                children: t('Current tenant')
            }),
            /*#__PURE__*/ jsx(Text, {
                variant: "medium",
                children: displayName
            }),
            /*#__PURE__*/ jsx(Text, {
                variant: "medium",
                children: defaultDomain
            }),
            shownTenantId ? /*#__PURE__*/ jsxs(Stack, {
                horizontal: true,
                tokens: {
                    childrenGap: 5
                },
                verticalAlign: "center",
                children: [
                    /*#__PURE__*/ jsx(Text, {
                        variant: "medium",
                        children: tenantId
                    }),
                    /*#__PURE__*/ jsx(FontIcon, {
                        "aria-label": tenantIconName,
                        iconName: tenantIconName,
                        onClick: handleCopyTenantClick,
                        className: classNames.fontIcon
                    })
                ]
            }) : /*#__PURE__*/ jsx(Link, {
                className: sharedClassNames.link,
                onClick: showTenantId,
                children: t('View tenant')
            })
        ]
    });
};

export { TenantDetails as default };
